const CreateDownloadLink = (data: any): string => {
  const obj = new Blob([data]);
  return window.URL.createObjectURL(obj);
};

const DownloadData = (data: any, name: string) => {
  const csvURL = CreateDownloadLink(data);
  const tempLink = document.createElement("a");
  tempLink.href = csvURL;
  tempLink.setAttribute("download", name);
  tempLink.click();
};

const DownloadFile = (url: string, filename?: string) => {
  const tempLink = document.createElement("a");
  tempLink.href = url;
  tempLink.setAttribute("download", filename || "download");
  tempLink.style.display = "none";
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
};

const OpenNewTab = (url: string) => {
  const w = window.open(url, "_blank");
  if (w) {
    w.focus();
  }
};

export { DownloadData, OpenNewTab, CreateDownloadLink, DownloadFile };
